
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^([79]28|787)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
